import React, { ReactElement } from 'react'

import { ConnectedSchedule } from '../../connectors'

const SchedulePage = (): ReactElement => <ConnectedSchedule />

export default SchedulePage
